import { useMutation, useQueryClient } from '@tanstack/react-query';
import { revokeUserPermission } from '../services/userRbac';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';

interface RevokePermissionParams {
    userId: string;
    permissionId: string;
}

export const useRevokePermissionMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, RevokePermissionParams>({
        mutationFn: ({ userId, permissionId }) => revokeUserPermission(userId, permissionId),
        onSuccess: (_, { userId }) => {
            queryClient.invalidateQueries({ queryKey: userKeys.permissions(userId) });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
